<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="block h-[1em] w-[1em]"
  >
    <!-- d4 tetrahedron: triangle die with three visible triangular faces -->
    <path d="M12 3 21 21 3 21Z" />
    <path d="M12 3 12 12" />
    <path d="M3 21 12 12" />
    <path d="M21 21 12 12" />
  </svg>
</template>
